import { useState, useEffect } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import { useNavigate } from "react-router-dom";
import AuthInfoObj from "../../ApiServices/AuthInfoObj.js";
import { APPID, DOMAIN_NAME, VERSION, REFERER } from "../../Config.js";
import { useLocation } from "react-router-dom";

const DthServices = () => {
  const navigate = useNavigate();
  const isLoggedIn =
    sessionStorage.getItem("session") && sessionStorage.getItem("sessionID");
  const [getNumData, setNumData] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [subscriberId, setSubscriberId] = useState();
  const [selectedOperatorData, setSelectedOperatorData] = useState(null);
  const [errors, setErrors] = useState({});
  const [isRechargeAttempted, setIsRechargeAttempted] = useState(false);
  const [userDetailPopUp, setUserDetailPopup] = useState(false);
  const [getDthUserDetailData, setDthUserDetailData] = useState([]);
  const [browsePlanPopup, setBrowsePlanPopup] = useState(false);
  const [getBrowsePlanData, setBrowsePlanData] = useState([]);
  const [input, setInput] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [getBalanceData, setBalanceData] = useState({});
  const [getDiscountAmtData, setDiscountAmtData] = useState({});
  const [successPopup, setSuccessPopup] = useState(false);
  const [getPaymentTransaction, setPaymentTransaction] = useState();
  const [getTransactionStatus, setTransactionStatus] = useState({});
  const [getPaymentModeData, setGetPaymentModeData] = useState([]);
  const [addMoneyPopup, setAddMoneyPopup] = useState(false);
  const [paymentGatewayData, setPaymentGatewayData] = useState({});
  const location = useLocation();
  const [isGetUserDetail, setGetUserDetail] = useState(false);
  const [isGetBrowsePlan, setGetBrowserPlan] = useState(false);
  const [isRechargeProcess, setGetRechargeProcess] = useState(false);

  const PG_TYPES = {
    PAYTM: 1,
    RZRPAY: 2,
    ICICIUPI: 3,
    AGRPAY: 4,
    UPIGATEWAY: 5,
    PAYU: 6,
    PAYTMJS: 7,
    CASHFREE: 8,
    CASHFREEDEMOTEST: 9,
    UPIGATEWAYNEW: 10,
    MITRAGATEWAY: 11,
    ALLUPI: 12,
    PHONEPE: 18,
    USDTGATEWAY: 19,
  };

  const getNumberList = async (e) => {
    try {
      const res = await ApiCalling.request(
        "POST",
        "/GetNumberList",
        null,
        null,
      );
      if (res?.statuscode === 1) {
        const operators = res?.data?.operators || [];
        setNumData(operators);
      } else {
        console.error(res?.msg, { toastId: "getNumberList error" });
      }
    } catch (error) {
      console.error("Error getNumberList :", error);
    }
  };

  const getDthUserDetail = async (e) => {
    setGetUserDetail(true);
    try {
      const bodyObject = {
        accountNo: subscriberId,
        oid: selectedOperator,
      };
      const res = await ApiCalling.request(
        "POST",
        "/GetRNPDTHCustInfo",
        bodyObject,
        null,
      );
      if (res?.statuscode === 1) {
        setDthUserDetailData(res?.dthciData?.data);
        setUserDetailPopup(true);
      } else {
        console.error(res?.msg, { toastId: "getDthUserDetail error" });
      }
    } catch (error) {
      console.error("Error getDthUserDetail :", error);
    } finally {
      setGetUserDetail(false);
    }
  };

  const dthRechargeSimplePlan = async () => {
    setGetBrowserPlan(true);
    try {
      const bodyObject = {
        accountNo: subscriberId,
        oid: selectedOperator,
      };

      const res = await ApiCalling.request(
        "POST",
        "/GetDTHSimplePlan",
        bodyObject,
        null,
      );

      if (res?.statuscode === 1) {
        setBrowsePlanData(res?.data);
        setBrowsePlanPopup(true);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error dthRechargeSimplePlan :", error);
    } finally {
      setGetBrowserPlan(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleRechargeClick = async () => {
    const newErrors = {};
    setIsRechargeAttempted(true);

    if (!selectedOperator) {
      newErrors.selectedOperator = "Please select an operator";
    }

    if (!subscriberId?.trim()) {
      newErrors.subscriberId = "Please enter Subscriber ID";
    } else {
      const regex = selectedOperatorData?.regExAccount
        ? new RegExp(selectedOperatorData.regExAccount)
        : null;

      if (regex && !regex.test(subscriberId)) {
        newErrors.subscriberId = "Invalid Subscriber ID format";
      }

      const minLength = selectedOperatorData?.length;
      const maxLength = selectedOperatorData?.lengthMax;

      if (
        (minLength && subscriberId.length < minLength) ||
        (maxLength && subscriberId.lengthMax > maxLength)
      ) {
        newErrors.subscriberId = `Subscriber ID must be between ${minLength} and ${maxLength} digits`;
      }
    }

    const enteredAmount = parseFloat(input.Amount);
    const minAmount = parseFloat(selectedOperatorData?.min);
    const maxAmount = parseFloat(selectedOperatorData?.max);

    if (!input.Amount || isNaN(enteredAmount)) {
      newErrors.Amount = "Please enter a valid amount";
    } else if (enteredAmount < minAmount || enteredAmount > maxAmount) {
      newErrors.Amount = `Amount must be between ₹${minAmount} and ₹${maxAmount}`;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;
    setGetRechargeProcess(true);
    try {
      if (!isLoggedIn) {
        sessionStorage.setItem(
          "pendingRecharge",
          JSON.stringify({
            subscriberId,
            amount: input?.Amount,
            operator: selectedOperator,
          }),
        );
        return navigate("/loginOtp");
      }
      sessionStorage.setItem(
        "pgRedirectedFrom",
        JSON.stringify({
          path: location.pathname,
          subscriberId,
          amount: input?.Amount,
          operator: selectedOperator,
        }),
      );
      await rechargeDiscountOffer(input?.Amount);
      await getBalanceUser();
      setShowPopup(true);
    } catch (error) {
      console.error("Recharge process failed", error);
    } finally {
      setGetRechargeProcess(false);
    }
  };

  const getBalanceUser = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetBalance",
        data: {},
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (res?.statuscode === 1) {
        setBalanceData(res?.data);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getBalanceUser :", error);
    }
  };

  const rechargeDiscountOffer = async (amount, operator) => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetCommissionAmount",
        data: {
          ID: 0,
          amount: amount,
          appid: APPID,
          imei: "",
          loginTypeID: 1,
          oid:
            operator !== undefined && operator !== null
              ? operator
              : selectedOperator,

          paymentID: 0,
          regKey: "",
          serialNo: "",
          session: AuthInfoObj().session,
          sessionID: AuthInfoObj().sessionID,
          userID: AuthInfoObj().userID,
          version: VERSION,
          Account: subscriberId,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res?.statuscode === 1) {
        setDiscountAmtData(res?.cashBackResp);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in rechargeDiscountOffer:", error);
    }
  };

  const paymentTransaction = async (amount, oid, accountNo) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const geoCode = `${latitude},${longitude}`;

        try {
          const res = await ApiCalling.apiClient.request({
            method: "POST",
            url: "/Transaction",
            data: {
              loginTypeID: 1,
              oid: oid,
              accountNo: accountNo,
              amount: amount,
              geoCode: geoCode,
              customerNo: "",
              imei: "",
              regKey: "",
              serialNo: "",
              o1: "",
              o2: "",
              o3: "",
              o4: "",
              fetchBilID: 0,
              isReal: false,
              refID: "",
              securityKey: "",
            },
            headers: {
              "Content-Type": "application/json",
              appid: APPID,
              version: VERSION,
              session: AuthInfoObj().session,
              sessionID: AuthInfoObj().sessionID,
              userID: AuthInfoObj().userID,
            },
          });

          if (res?.statuscode === 1) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else if (res?.statuscode === 2) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else if (res?.statuscode === 3) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else {
            console.error(res?.msg);
          }
          setPaymentTransaction(res);
          setShowPopup(false);
          setSuccessPopup(true);
        } catch (error) {
          console.error("Error in paymentTransaction:", error);
        }
      },
      (error) => {
        console.error("Failed to fetch geolocation:", error);
      },
    );
  };

  const getPaymentMode = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetPaymentMode",
        data: {},
        headers: {
          "Content-Type": "application/json",
          appid: APPID,
          version: VERSION,
          session: AuthInfoObj().session,
          sessionID: AuthInfoObj().sessionID,
          userID: AuthInfoObj().userID,
          loginTypeID: 1,
        },
      });

      if (res?.statuscode === 1) {
        setGetPaymentModeData(res.data.operators || []);
        setShowPopup(false);
        setAddMoneyPopup(true);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in rechargeDiscountOffer:", error);
    }
  };

  const handleClickGateway = (id, remainamt) => {
    getPGDetail(id, remainamt);
  };

  const getPGDetail = async (id, remainamt) => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetPGDetail",
        data: {
          id: id,
          a: remainamt.toString(),
          w: 1,
          vpa: "",
        },
        headers: {
          "Content-Type": "application/json",
          AppID: APPID,
          Version: VERSION,
          Session: AuthInfoObj().session,
          SessionID: AuthInfoObj().sessionID,
          UserID: AuthInfoObj().userID,
          Referer: REFERER,
        },
      });

      if (res?.statuscode === 1) {
        const data = res?.pGModelForWeb;

        switch (data?.pgType) {
          case PG_TYPES.PAYTMJS:
            setPaymentGatewayData({
              type: "paytm",
              paytmJSRequest: data?.paytmJSRequest,
            });
            break;

          case PG_TYPES.RZRPAY:
            setPaymentGatewayData({
              type: "razorpay",
              razorData: data,
            });
            break;

          case PG_TYPES.CASHFREE:
          case PG_TYPES.CASHFREEDEMOTEST:
            setPaymentGatewayData({
              type: "cashfree",
              cashfreeData: data,
            });
            break;

          case PG_TYPES.PHONEPE:
            setPaymentGatewayData({
              type: "phonepe",
              phonepeData: data,
            });
            break;

          default:
            alert("Unsupported or unhandled payment gateway: " + data?.pgType);
            break;
        }
        setAddMoneyPopup(false);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in getPGDetail:", error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const closeRechargePopup = () => {
    setShowPopup(false);

    setSelectedOperator("");
    setSubscriberId("");
    setSelectedOperatorData(null);

    setInput({});
    setErrors({});
    setIsRechargeAttempted(false);
  };

  const closeSuccessPopup = () => {
    setSuccessPopup(false);

    setSelectedOperator("");
    setSubscriberId("");
    setSelectedOperatorData(null);

    setInput({});
    setErrors({});
    setIsRechargeAttempted(false);
  };

  const closeAddMoneyPopup = () => {
    setAddMoneyPopup(false);

    setSelectedOperator("");
    setSubscriberId("");
    setSelectedOperatorData(null);

    setInput({});
    setErrors({});
    setIsRechargeAttempted(false);

    setDiscountAmtData({});
    setBalanceData({});
  };

  return {
    getNumberList,
    getNumData,
    filteredList,
    setFilteredList,
    selectedOperator,
    getDthUserDetail,
    dthRechargeSimplePlan,
    subscriberId,
    setSubscriberId,
    setSelectedOperator,
    handleRechargeClick,
    selectedOperatorData,
    setSelectedOperatorData,
    errors,
    isRechargeAttempted,
    getDthUserDetailData,
    userDetailPopUp,
    setUserDetailPopup,
    setErrors,
    browsePlanPopup,
    getBrowsePlanData,
    setBrowsePlanPopup,
    handleChange,
    input,
    showPopup,
    getBalanceData,
    paymentGatewayData,
    addMoneyPopup,
    getPaymentModeData,
    getTransactionStatus,
    getPaymentTransaction,
    successPopup,
    getDiscountAmtData,
    paymentTransaction,
    handleClickGateway,
    getPaymentMode,
    setShowPopup,
    getBalanceUser,
    rechargeDiscountOffer,
    setSuccessPopup,
    setAddMoneyPopup,
    setInput,
    isGetUserDetail,
    isGetBrowsePlan,
    isRechargeProcess,
    handlePrint,
    closeRechargePopup,
    closeSuccessPopup,
    closeAddMoneyPopup,
  };
};

export default DthServices;
